// Generated by ReScript, PLEASE EDIT WITH CARE

import * as NovaEmotion from "@cosmonexus/nova-emotion";

let brand = {
  primary: NovaEmotion.theme.color.accent1,
  "primary-light": NovaEmotion.theme.color.accent2,
  "primary-dark": NovaEmotion.theme.color.accent3,
  secondary: NovaEmotion.theme.color.accent2,
  "secondary-light": NovaEmotion.theme.color.accent1,
  "secondary-dark": NovaEmotion.theme.color.accent3
};

let semantic = {
  success: NovaEmotion.theme.color.success,
  "success-light": NovaEmotion.theme.color.success,
  "success-dark": NovaEmotion.theme.color.success,
  warning: NovaEmotion.theme.color.warning,
  "warning-light": NovaEmotion.theme.color.warning,
  "warning-dark": NovaEmotion.theme.color.warning,
  error: NovaEmotion.theme.color.error,
  "error-light": NovaEmotion.theme.color.error,
  "error-dark": NovaEmotion.theme.color.error,
  info: NovaEmotion.theme.color.accent1,
  "info-light": NovaEmotion.theme.color.accent2,
  "info-dark": NovaEmotion.theme.color.accent3
};

let text = {
  primary: NovaEmotion.theme.color.text1,
  secondary: NovaEmotion.theme.color.text2,
  disabled: NovaEmotion.theme.color.text3,
  inverse: NovaEmotion.theme.color.surface0
};

let background = {
  primary: NovaEmotion.theme.color.surface0,
  secondary: NovaEmotion.theme.color.surface1,
  elevated: NovaEmotion.theme.color.surface2,
  overlay: "rgba(0, 0, 0, 0.5)",
  inverse: NovaEmotion.theme.color.text1
};

let border = {
  default: NovaEmotion.theme.color.surface3,
  hover: NovaEmotion.theme.color.surface4
};

let placeholder = NovaEmotion.theme.color.text3;

let Colors = {
  brand: brand,
  semantic: semantic,
  text: text,
  background: background,
  border: border,
  placeholder: placeholder
};

let fontFamily = {
  sans: NovaEmotion.theme.font.sans,
  serif: "'Playfair Display', Georgia, 'Times New Roman', serif",
  mono: NovaEmotion.theme.font.mono
};

let fontSize = {
  xs: NovaEmotion.theme.fontSize.xs,
  sm: NovaEmotion.theme.fontSize.sm,
  base: NovaEmotion.theme.fontSize.base,
  lg: NovaEmotion.theme.fontSize.lg,
  xl: NovaEmotion.theme.fontSize.xl,
  "2xl": NovaEmotion.theme.fontSize.xxl,
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem"
};

let fontWeight = {
  thin: "100",
  light: "300",
  normal: "400",
  medium: NovaEmotion.theme.fontWeight.medium,
  semibold: NovaEmotion.theme.fontWeight.semibold,
  bold: NovaEmotion.theme.fontWeight.bold,
  extrabold: "800"
};

let lineHeight = {
  tight: NovaEmotion.theme.lineHeight.tight,
  snug: "1.375",
  normal: NovaEmotion.theme.lineHeight.normal,
  relaxed: "1.625",
  loose: "2"
};

let letterSpacing = {
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
  widest: "0.1em"
};

let Typography = {
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  letterSpacing: letterSpacing
};

let scale = {
  "0": "0",
  px: "1px",
  "0.5": "0.125rem",
  "1": NovaEmotion.theme.space[1],
  "1.5": "0.375rem",
  "2": NovaEmotion.theme.space[2],
  "2.5": "0.625rem",
  "3": NovaEmotion.theme.space[3],
  "3.5": "0.875rem",
  "4": NovaEmotion.theme.space[4],
  "5": NovaEmotion.theme.space[5],
  "6": NovaEmotion.theme.space[6],
  "7": "1.75rem",
  "8": NovaEmotion.theme.space[8],
  "9": "2.25rem",
  "10": NovaEmotion.theme.space[10],
  "12": "3rem",
  "14": "3.5rem",
  "16": "4rem",
  "20": "5rem",
  "24": "6rem",
  "32": "8rem",
  "40": "10rem",
  "48": "12rem",
  "56": "14rem",
  "64": "16rem"
};

let Spacing = {
  scale: scale
};

let radius = {
  none: "0",
  sm: NovaEmotion.theme.radius.sm,
  base: "0.25rem",
  md: NovaEmotion.theme.radius.md,
  lg: NovaEmotion.theme.radius.lg,
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: NovaEmotion.theme.radius.full
};

let width = {
  "0": "0",
  "1": "1px",
  "2": "2px",
  "4": "4px",
  "8": "8px"
};

let Borders = {
  radius: radius,
  width: width
};

let elevation = {
  none: "none",
  sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  base: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  md: NovaEmotion.theme.shadow.md,
  lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
  "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)"
};

let colored = {
  primary: NovaEmotion.theme.focusRing,
  success: NovaEmotion.theme.focusRing,
  warning: NovaEmotion.theme.focusRing,
  error: NovaEmotion.theme.focusRing
};

let Shadows = {
  elevation: elevation,
  colored: colored
};

let duration = {
  fastest: "150ms",
  fast: NovaEmotion.theme.transition.fast,
  normal: NovaEmotion.theme.transition.normal,
  slow: NovaEmotion.theme.transition.slow,
  slowest: "800ms"
};

let easing = {
  linear: "linear",
  ease: "ease",
  "ease-in": "ease-in",
  "ease-out": NovaEmotion.theme.easing.out,
  "ease-in-out": NovaEmotion.theme.easing.inOut,
  bounce: "cubic-bezier(0.68, -0.55, 0.265, 1.55)"
};

let transition = {
  fast: "all " + NovaEmotion.theme.transition.fast + " " + NovaEmotion.theme.easing.out,
  normal: "all " + NovaEmotion.theme.transition.normal + " " + NovaEmotion.theme.easing.out,
  slow: "all " + NovaEmotion.theme.transition.slow + " " + NovaEmotion.theme.easing.out,
  colors: "background-color 200ms ease-out, border-color 200ms ease-out, color 200ms ease-out",
  transform: "transform 200ms ease-out",
  opacity: "opacity 200ms ease-out"
};

let Animations = {
  duration: duration,
  easing: easing,
  transition: transition
};

let values = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
};

let media = {
  sm: `@media (min-width: ` + values.sm + `)`,
  md: `@media (min-width: ` + values.md + `)`,
  lg: `@media (min-width: ` + values.lg + `)`,
  xl: `@media (min-width: ` + values.xl + `)`,
  "2xl": `@media (min-width: ` + values["2xl"] + `)`
};

let Breakpoints = {
  values: values,
  media: media
};

let scale$1 = {
  hide: "-1",
  auto: "auto",
  base: "0",
  docked: "10",
  dropdown: "1000",
  sticky: "1100",
  banner: "1200",
  overlay: "1300",
  modal: "1400",
  popover: "1500",
  tooltip: "1600"
};

let ZIndex = {
  scale: scale$1
};

let button = {
  height: {
    sm: "2rem",
    md: "2.5rem",
    lg: "3rem",
    xl: "3.5rem"
  },
  padding: {
    sm: "0.5rem 0.75rem",
    md: "0.625rem 1rem",
    lg: "0.75rem 1.25rem",
    xl: "0.875rem 1.5rem"
  }
};

let input = {
  height: {
    sm: "2rem",
    md: "2.5rem",
    lg: "3rem"
  },
  padding: "0.5rem 0.75rem"
};

let Components = {
  button: button,
  input: input
};

let Theme = {
  Colors: Colors,
  Typography: Typography,
  Spacing: Spacing,
  Borders: Borders,
  Shadows: Shadows,
  Animations: Animations,
  Breakpoints: Breakpoints,
  ZIndex: ZIndex,
  Components: Components
};

export {
  Theme,
}
/* brand Not a pure module */
